import React, { useEffect } from "react";
import Layout from "../components/Layout";

function StripeBuy() {
  useEffect(() => {
    // Prüfe, ob das Script bereits existiert
    const existingScript = document.querySelector(
      'script[src="https://js.stripe.com/v3/buy-button.js"]'
    );

    if (!existingScript) {
      // Lade das Stripe Buy Button Script
      const script = document.createElement("script");
      script.src = "https://js.stripe.com/v3/buy-button.js";
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <div style={{ 
      display: "flex", 
      justifyContent: "center", 
      alignItems: "center", 
      minHeight: "60vh",
      padding: "2rem"
    }}>
      <stripe-buy-button
        buy-button-id="buy_btn_1T0P3BBtYmUS0JIQNACuf0iD"
        publishable-key="pk_live_51Or249BtYmUS0JIQ5frVZCPTVRge2u3CWMILugF3cTuOpcPpyeq9dJeBI2kQddPBp8XthHhuha8aBbVMPwlfAlEh00fvjpcO3O"
      />
    </div>
  );
}

export default StripeBuy;
